import { useTranslation } from 'react-i18next';

export const MAGNIFICENT_7 = 0;
export const ACTIONS_AND_BLOCKS = 1;

export const useTranslatedOptions = () => {
  const { t } = useTranslation('CategoryManagerDetails');

  return [
    {
      value: MAGNIFICENT_7,
      label: t('tabs.bigPicture'),
    },
    {
      value: ACTIONS_AND_BLOCKS,
      label: t('tabs.actionsAndBlocks'),
    },
  ];
};

export const emptyData = {
  category: null,
  actions: [],
  blocks: [],
};

export type FilterOptions = {
  value: 'all' | 'starred' | 'planned' | 'unplanned' | 'completed';
  label: string;
};

export const useTranslatedFilterOptions = (): FilterOptions[] => {
  const { t } = useTranslation('CategoryManagerDetails');

  return [
    { value: 'all', label: t('filterOptions.viewAll') },
    { value: 'starred', label: t('filterOptions.starred') },
    { value: 'planned', label: t('filterOptions.planned') },
    { value: 'unplanned', label: t('filterOptions.unplanned') },
    { value: 'completed', label: t('filterOptions.completed') },
  ];
};

// Legacy exports for backward compatibility
export const OPTIONS = [
  {
    value: MAGNIFICENT_7,
    label: 'Magnificent 7',
  },
  {
    value: ACTIONS_AND_BLOCKS,
    label: 'Actions and Blocks',
  },
];

export const selectFilterOptions: FilterOptions[] = [
  { value: 'all', label: 'View All' },
  { value: 'starred', label: 'Starred' },
  { value: 'planned', label: 'Planned' },
  { value: 'unplanned', label: 'Unplanned' },
  { value: 'completed', label: 'Completed' },
];
